import type { FunctionComponent } from 'react';
import { Badge, paletteHelper, Switch, typographyHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { PropertyRelationship } from '../PropertyRelationship';

const StyledFollowLabel = styled.p`
  ${typographyHelper('body02')};
  color: ${paletteHelper('textSecondary')};
  cursor: pointer;
`;

const FollowPropertyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledBadge = styled(Badge)`
  cursor: pointer;
`;

const formatStringToSentenceCase = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const formatPropertyRelationshipString = (
  propertyRelationship: PropertyRelationship,
): string => formatStringToSentenceCase(propertyRelationship.replace(/[^a-zA-Z ]/g, ' '));

interface FollowPropertyProps {
  followed: boolean;
  relationship?: PropertyRelationship;
  onToggleChange: (checked?: boolean) => void;
  tooltip?: string;
  disabled?: boolean;
}
export const FollowPropertySwitch: FunctionComponent<FollowPropertyProps> = ({
  followed,
  onToggleChange,
  tooltip,
  relationship,
  disabled = false,
}) => {
  return (
    <FollowPropertyWrapper>
      {relationship && (
        <StyledBadge variant="callout" onClick={() => onToggleChange(false)}>
          {formatPropertyRelationshipString(relationship)}
        </StyledBadge>
      )}
      {!relationship && (
        <StyledFollowLabel onClick={() => onToggleChange(true)}>Follow</StyledFollowLabel>
      )}
      <Switch
        id="followed-property-switch"
        label=""
        checked={followed}
        tooltip={tooltip}
        disabled={disabled}
        onChange={onToggleChange}
      />
    </FollowPropertyWrapper>
  );
};
